import VideoEmbed from '@app/components/VideoEmbed'
import { bindFunctions } from '@app/utils/class'
import { Tutorial, TUTORIALS } from '@app/utils/tutorials'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Card, CardBody, CardHeader } from 'reactstrap/lib'

import './TutorialsListPage.module.scss'

export default class TutorialsListPage extends React.PureComponent {
  constructor(props: any) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title='Admin - Tutorials'>
        <div>
          <div className='p-4 border-bottom'>
            <h3>Tutorials</h3>
            <p>Learn how to use the platform with these tutorials.</p>
          </div>
          {TUTORIALS.length > 0 ? (
            <div>
              <div className='my-4 px-4'>
                {this._renderVideoCard(TUTORIALS[0])}
              </div>
              <div className='tutorials-grid'>
                {TUTORIALS.slice(1).map((t) => (
                  this._renderVideoCard(t)
                ))}
              </div>
            </div>
          ) : (
            <div className='p-4 text-center'>No tutorials available.</div>
          )}
        </div>
      </DocumentTitle>
    )
  }

  private _renderVideoCard(t: Tutorial) {
    return (
      <Card key={t.videoId} className='tutorial-video-container shadow'>
        <CardHeader className='px-3 py-2'>
          <h5 className='m-0 text-center'>{t.title}</h5>
        </CardHeader>
        <CardBody className='p-3'>
          <VideoEmbed className='tutorial-video' videoId={t.videoId} title={t.title} />
        </CardBody>
      </Card>
    )
  }
}